export function useGeneralHelpers() {
  function createBatches(idList, batchSize = 30) {
    // break into batches of 30 for firestore 'in' query due to firestore query limitations.
    const batches = []
    let batch = []
    for (let i = 0; i < idList.length; i++) {
      if (batch.length < batchSize) {
        batch.push(idList[i])
      } else {
        batches.push(batch)
        batch = []
      }
    }
    if (batch.length > 0) {
      batches.push(batch)
    }
    return batches
  }

  const standardizeContact = contact => {
    // Naxos surfaces Apollo's obfuscated last name (e.g. "Sm***h") in `last_name_obfuscated`
    // when the contact isn't enriched, and the full last name in `last_name` once enriched.
    const useLastName = contact.last_name_obfuscated
      ? contact.last_name_obfuscated[0] + '.'
      : contact.last_name

    const name = `${contact.first_name} ${useLastName || ''}`.trim()

    const standardizedExternalId =
      contact.external_ids?.APOLLO ||
      contact.external_ids?.SWARM ||
      contact.external_ids?.UPLEAD ||
      contact.external_contact_id ||
      null

    return { ...contact, standardizedExternalId, name }
  }

  const removeStandardizedFields = contact => {
    const newContact = JSON.parse(JSON.stringify(contact))
    delete newContact.standardizedExternalId
    // FE-only enrichment marker, not for persistence.
    delete newContact._enriched
    if (newContact.external_ids) {
      delete newContact.id
    }
    return newContact
  }

  const contactEmailIsUnlocked = contact => {
    const emailExists = contact?.email
    const emailUnlocked = contact?.email !== 'email_not_unlocked@domain.com'
    return emailExists && emailUnlocked
  }

  const stripScheme = url => {
    // Normalize a website to a bare domain for naxos `/search` and `/enrich`.
    // Apollo's `q_organization_domains` rejects schemes, www., and trailing slashes.
    if (!url) return ''
    return url
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/\/$/, '')
  }

  const requestReadyFilter = filter => {
    // maps fields from display into the fields that go into the filter requests for `accounts/list`
    // territory_list_id -> list_id
    let stringFilter = JSON.stringify(filter)
    stringFilter = stringFilter.replaceAll('"field":"territory_list_id"', '"field":"list_id"')
    return JSON.parse(stringFilter)
  }

  return {
    createBatches,
    standardizeContact,
    removeStandardizedFields,
    contactEmailIsUnlocked,
    stripScheme,
    requestReadyFilter
  }
}
